<template>
  <div>
    <el-row>
      <el-col :span="5">
        <p>公司：{{ AB_NAME }}</p>
      </el-col>
      <el-col :span="9">
        <p>
          报价有效期：{{ NEXT_START_DATE }}&nbsp;&nbsp;至&nbsp;&nbsp;{{ NEXT_END_DATE }}
        </p>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top: 0; margin-top: 0" size="medium">
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="产品名称：" @keyup.enter.native="handleSearch">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-form-item>
          <el-button type="primary" id="search" @click="handleSearch()" :loading="loadSearch">筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="importDialog = true" v-show="fun_dic[103000301]">导入报价</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row v-loading="loading" style="width: 100%">
      <el-col>
        <el-tabs type="card" v-model="activeTab" @tab-click="handleFirstCatalogClick">
          <el-tab-pane v-for="item in firstCatalogData" :name="item.INNER_CODE.toString()" :label="item.NAME" :key="item.INNER_CODE" :data="item"
            :code="item.INNER_CODE"></el-tab-pane>
        </el-tabs>
        <el-tabs @tab-click="handleSecondCatalogClick" v-model="activeName" :tab-position="'left'" class="second">
          <el-tab-pane v-for="item in secondCatalogData" :name="item.INNER_CODE.toString()" ref="secondCat" :label="item.NAME" :key="item.INNER_CODE"
            :code="item.INNER_CODE">
          </el-tab-pane>
          <!-- 产品列表 -->
          <el-col class="product_main" :xl="23" :md="21" :lg="22">
            <div v-loading="loading1" ref="products_view">
              <div v-for="item in productCatalogData" :key="item.INNER_CODE">
                <el-col :xl="4" :lg="6" :md="8" :sm="8" :xs="8" style="padding: 10px">
                  <div class="card">
                    <div class="text">
                      <div :title="item.NAME">
                        <p style="font-weight: bold" class="productName">
                          {{ item.NAME }}
                        </p>
                      </div>
                      <div>
                        <span>当前价格：&nbsp;&nbsp;&nbsp;&nbsp;{{
                        item.CURRENT_PRICE
                        }}</span>
                        <p>
                          <span>产品单位：&nbsp;&nbsp;&nbsp;&nbsp;{{
                          item.TYPE_UNIT
                          }}</span>
                        </p>
                        <!--<p v-if="myWeek === 1||myWeek === 2"><span style="width: 40%">报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</span>-->
                        <!--<el-input type="text" clearable v-model="item.SUBMIT_PRICE" style="width: 45%"></el-input>-->
                        <!--</p>-->
                        <p>
                          <span style="width: 40%">报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</span>
                          <el-input type="text" clearable v-model="item.SUBMIT_PRICE" @change="(e) => { setValue(e, item) }" style="width: 45%">
                          </el-input>
                        </p>
                        <p v-if="customerType == 1">
                          <span style="width: 40%">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;率：</span>
                          <el-input type="text" clearable v-model="item.SUBMIT_TAX_RATE" style="width: 45%" @change="setValue(item)">
                          </el-input>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </div>
            </div>
          </el-col>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: right">
        <el-button @click="handleSubmit" v-show="customerId !== 454 && customerId !== 723" v-if="status === '未审核'"
          :disabled="disableButton == 1 ? true : false">
          提交
        </el-button>
      </el-col>
    </el-row>
    <el-dialog title="导入供应商价格" center :visible.sync="importDialog" width="500px">
      <el-form ref="importForm" :model="importForm" style="margin-left: 30px" size="small">
        <el-form-item label="上传文件：">
          <limit-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
            :name="importForm.file" :file-list="importForm.fileList">
            <el-button type="primary">点击上传</el-button>
          </limit-upload>
          <p style="color: #409EFF" @click="downloadImportFormTmp">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false">取 消</el-button>
        <el-button @click="submitImport('importForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getTotal, getProduct, priceSubmit, priceSearch,
} from 'api/givePrice';
import validation from '@/assets/common/validation';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      PAGE_ID: '1030003', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 103000301: 0 },
      loading: true,
      loadSearch: false,
      myWeek: '',
      supplierName: this.$route.params.name,
      firstCatalogCode: 0,
      secondCatalogCode: 0,
      firstCatalogData: [],
      secondCatalogData: [],
      //   产品列表
      productCatalogData: [],
      catalogData: [],
      code: '',
      activeName: '',
      activeTab: '',
      AB_NAME: sessionStorage.getItem('company'),
      NEXT_START_DATE: sessionStorage.getItem('startTime'),
      NEXT_END_DATE: sessionStorage.getItem('endTime'),
      loading1: false,
      // 存放全部的产品信息
      ALL_PRODUCTS: [],
      // 产品是否加载完毕
      isLoadComplate: false,
      // 下滑加载的次数
      loadCount: 1,
      // 当前滚动距离顶部的距离
      currentTop: 0,
      searchForm: {
        name: '',
      },
      productArray: [],
      pageSize: 10,
      status: sessionStorage.getItem('status'),
      disableButton: 0,
      customerType: sessionStorage.getItem('customerType'),
      customerId: Number(this.$route.params.submitId),
      importDialog: false,
      importForm: {
        file: 'tmp',
        fileList: [],
        url: '',
      },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // 超过报价日期 禁止提交 二次修改
    const sa = new Date();
    const a = `${sa.getFullYear()}-${sa.getMonth() + 1}-${sa.getDate()}`;
    const oDate1 = new Date(sessionStorage.getItem('endTime'));
    const oDate2 = new Date(a);
    if (oDate1.getTime() < oDate2.getTime()) {
      this.disableButton = 1;
    }
    this.queryBeforeFun();
    this.queryGetTime();
    this.defaultQuery();
  },
  mounted() {
    // 监听产品框的滚动事件
    const PRODUCTS_VIEW = this.$refs.products_view;
    PRODUCTS_VIEW.addEventListener('scroll', () => {
      const SCROLL_TOP = PRODUCTS_VIEW.scrollTop;
      if (SCROLL_TOP > 0 && SCROLL_TOP % 5 === 0 && SCROLL_TOP > this.currentTop && !this.isLoadComplate) {
        this.loadProducts(this.loadCount);
        this.loadCount++;
        this.currentTop = SCROLL_TOP;
      }
    });
    this.setViewHeight();
  },
  tab(date1, date2) {
    const oDate1 = new Date(date1);
    const oDate2 = new Date(date2);
    if (oDate1.getTime() > oDate2.getTime()) {
    } else {
    }
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    downloadImportFormTmp() {
      const params = {
        SERVICE_ID: '10040',
        OTYPE: 100,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.customerId,
      };
      http.post(params).then((result) => {
        if (result[0]) window.open(this.$util.getURLLocalHost(result[0]));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitImport() {
      if (!this.importForm.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10040',
        OTYPE: 101,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.customerId,
        FILE_NAME: this.importForm.url,
        // 预留参数税率，暂无作用
        TAX_RATE: 0,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '导入成功', type: 'success' });
        this.importForm.fileList = [];
        this.importForm.url = '';
        this.importDialog = false;
        this.defaultQuery();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.importForm.fileList = [];
        this.importForm.url = '';
        this.$refs.importForm.resetFields();
      });
    },
    handleSuccess(response, file, fileList) {
      this.importForm.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.importForm.fileList = [];
      this.importForm.url = '';
    },
    //   动态设置产品列表的高度
    setViewHeight() {
      this.$refs.products_view.style.height = `${window.innerHeight - 365}px`;
      this.$refs.products_view.style.overflowY = 'scroll';
    },
    queryGetTime() {
      const mydate = new Date();
      this.myWeek = mydate.getDay(); // 获取存储当前日期
    },
    defaultQuery() {
      const data = {
        CUSTOMER_ID: this.$route.params.submitId,
        CUSTOMER_TYPE: this.customerType,
      };
      this.loadSearch = true;
      getTotal(data).then((result) => {
        if (result[0]) {
          this.firstCatalogData = result[0].CATALOGS;
          this.secondCatalogData = this.firstCatalogData[0].SECOND_CATALOGS;
          this.activeTab = this.firstCatalogData[0].INNER_CODE.toString();
          this.activeName = this.secondCatalogData[0].INNER_CODE.toString();
          this.ALL_PRODUCTS = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.loadProducts();
        }
        this.loading = false;
        this.loading1 = false;
        this.loadSearch = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loadSearch = false;
        this.loading = false;
        this.loading1 = false;
      });
    },
    // 分批加载数据
    loadProducts(pageIndex = 0, pageSize = this.pageSize) {
      const INDEX = pageIndex * pageSize;
      // 注意slice()函数的用法,前闭后开[)
      const END = INDEX + pageSize;
      if (this.productCatalogData.length < this.ALL_PRODUCTS.length && INDEX < this.ALL_PRODUCTS.length) {
        if (END > this.ALL_PRODUCTS.length) {
          this.productCatalogData.push(...this.ALL_PRODUCTS.slice(INDEX));
        } else {
          this.productCatalogData.push(...this.ALL_PRODUCTS.slice(INDEX, END));
        }
      } else {
        // 已经加载完毕
        this.isLoadComplate = true;
      }
    },
    // 初始化下滑加载条件
    $_initLoadCondition() {
      this.productCatalogData = [];
      this.loadCount = 1;
      this.currentTop = 0;
      this.isLoadComplate = false;
    },
    handleFirstCatalogClick(content) {
      this.loading1 = true;
      this.firstCatalogCode = content.$attrs.code;
      this.catalogData = content.$attrs.data;
      this.secondCatalogData = this.catalogData.SECOND_CATALOGS;
      this.secondCatalogCode = this.secondCatalogData[0].INNER_CODE;
      this.activeName = this.secondCatalogCode.toString();
      this.handleProduct(this.secondCatalogCode);
    },
    handleProduct(content) {
      this.loading1 = true;
      //   初始化加载属性
      this.$_initLoadCondition();
      const data = {
        CUSTOMER_ID: this.$route.params.submitId,
        CUSTOMER_TYPE: this.customerType,
        SECOND_CATALOG_CODE: content,
      };
      getProduct(data)
        .then((result) => {
          if (result[0]) {
            this.ALL_PRODUCTS = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
            this.loadProducts();
            this.loading1 = false;
          } else {
            this.productCatalogData = [];
            this.loading1 = false;
          }
        })
        .catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
          this.loading = false;
          this.loading1 = false;
        });
    },
    handleSecondCatalogClick(content) {
      this.loading1 = true;
      this.secondCatalogCode = content.$attrs.code;
      this.$_initLoadCondition();
      const data = {
        CUSTOMER_ID: this.$route.params.submitId,
        CUSTOMER_TYPE: this.customerType,
        SECOND_CATALOG_CODE: this.secondCatalogCode,
      };
      getProduct(data).then((result) => {
        if (result[0]) {
          this.ALL_PRODUCTS = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.loadProducts();
          this.loading1 = false;
        } else {
          this.productCatalogData = [];
          this.loading1 = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
        this.loading1 = false;
      });
    },
    handleSubmit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.productArray.length !== 0) {
            const data = {
              CUSTOMER_ID: this.$route.params.submitId,
              CUSTOMER_TYPE: this.customerType,
              SECOND_CATALOG_CODE: this.secondCatalogCode,
              PRICE_ARRAY: this.productArray,
            };
            priceSubmit(data).then((result) => {
              this.$message.show({ text: '商品报价成功', type: 'success' });
              document.body.style.cursor = 'default';
            })
              .catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
          } else {
            this.$message.show({ text: '您未修改报价', type: 'error' });
            document.body.style.cursor = 'default';
          }
        } finally {}
      }
    },
    handleSearch() {
      if (this.searchForm.name) {
        const data = {
          CUSTOMER_ID: this.$route.params.submitId,
          PRODUCT_NAME: this.searchForm.name,
          CUSTOMER_TYPE: this.customerType,
        };
        this.loadSearch = true;
        priceSearch(data).then((result) => {
          this.productCatalogData = result.map((item) => ({ ...item, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.loadSearch = false;
        }).catch((error) => {
          this.loadSearch = false;
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.productCatalogData = [];
        this.defaultQuery();
      }
    },
    setValue(e, item) {
      if (!validation.价格正数验证(item.SUBMIT_PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      this.productArray = this.productCatalogData.filter((item) => item.CURRENT_PRICE !== item.SUBMIT_PRICE || item.TAX_RATE !== item.SUBMIT_TAX_RATE).map((item) => ({
        PRODUCT_CODE: item.INNER_CODE,
        SUBMIT_PRICE: parseFloat(item.SUBMIT_PRICE),
        TAX_RATE: Number(item.SUBMIT_TAX_RATE),
        CATALOG_ID: item.CATALOG_ID,
      }));
    },
  },
};
</script>
<style scoped>
.el-tabs__item {
  width: 100px !important;
  text-align: center;
}

.text {
  font-size: 14px;
  margin: 10px;
}

.card {
  width: 100%;
  /* height: 230px; */
  height: fit-content;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.second .el-tab-pane {
  height: 600px;
  overflow-y: auto;
}

.productName {
  height: 35px;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.product_main {
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/supplierProduct.vue